export const t = {
  nav: {
    cs: { home: "Hlavni", services: "Sluzby", routes: "Trasy a ceny", about: "O nas", contacts: "Kontakty", faq: "FAQ" },
    en: { home: "Home", services: "Services", routes: "Routes & Prices", about: "About", contacts: "Contacts", faq: "FAQ" },
  },
  hero: {
    cs: {
      overline: "PREPRAVA PO CELE EVROPE",
      title: "EVROPSKA LOGISTIKA & VIP TRANSFERY",
      subtitle: "Rodinná přepravní společnost z Prahy. Osobní i nákladní přeprava po celé Evropě.",
      cta: "Kontaktujte nás",
    },
    en: {
      overline: "TRANSPORT ACROSS ALL OF EUROPE",
      title: "EUROPEAN LOGISTICS & VIP TRANSFERS",
      subtitle: "Family transport company from Prague. Passenger and cargo transport across Europe.",
      cta: "Contact us",
    },
  },
  trust: {
    cs: ["4 profesionální řidiči", "Osobní & nákladní přeprava", "Po celé Evropě", "Rodinná firma"],
    en: ["4 professional drivers", "Passenger & cargo transport", "Europe-wide", "Family business"],
  },
  services: {
    cs: {
      sectionTitle: "Naše služby",
      items: [
        { id: "business-car", title: "Business transfer", desc: "Setkání a doprovod z letišť, obchodní cesty. Luxusní vůz business třídy.", price: "od 35 €", link: "/services/business-car" },
        { id: "minibus", title: "Mikrobus 9 míst", desc: "Skupinové transfery, turistické a firemní cesty po celé Evropě.", price: "od 280 €", link: "/services/minibus" },
        { id: "cargo", title: "Sprinter celokový", desc: "Stěhování, nábytek, obchodní zásilky. Objem až 14 m³.", price: "od 280 €", link: "/services/cargo" },
        { id: "pallet", title: "Furgon 12 europalet", desc: "Paletové a sběrné zásilky pro firmy. Až 12 europalet.", price: "od 580 €", link: "/services/pallet" },
      ],
    },
    en: {
      sectionTitle: "Our services",
      items: [
        { id: "business-car", title: "Business transfer", desc: "Airport meet & greet, business trips. Luxury business-class car.", price: "from 35 €", link: "/services/business-car" },
        { id: "minibus", title: "Minibus 9 seats", desc: "Group transfers, tourist and corporate trips across Europe.", price: "from 280 €", link: "/services/minibus" },
        { id: "cargo", title: "Sprinter full-metal", desc: "Moves, furniture, business cargo. Volume up to 14 m³.", price: "from 280 €", link: "/services/cargo" },
        { id: "pallet", title: "Van 12 europallets", desc: "Pallet and groupage cargo for businesses. Up to 12 europallets.", price: "from 580 €", link: "/services/pallet" },
      ],
    },
  },
  servicePages: {
    cs: {
      "business-car": {
        title: "Business transfer",
        heroDesc: "Setkání a doprovod z letišť, obchodní cesty po celé Evropě. Komfortní automobil business třídy s profesionálním řidičem.",
        specs: ["Luxusní sedan business třídy", "Profesionální řidič", "Wi-Fi na palubě", "Dětská sedačka na vyžádání", "Přeprava po celé Evropě"],
        routes: [
          { route: "Praha — centrum", price: "od 35 €" },
          { route: "Praha — Vídeň", price: "od 180 €" },
          { route: "Praha — Berlín", price: "od 350 €" },
          { route: "Praha — Mnichov", price: "od 280 €" },
        ],
        cta: "Objednat přes WhatsApp",
      },
      minibus: {
        title: "Mikrobus 9 míst",
        heroDesc: "Skupinové transfery, turistické a firemní cesty po celé Evropě. Pohodlný mikrobus pro až 9 cestujících.",
        specs: ["9 pohodlných sedadel", "Klimatizace", "Velký zavazadlový prostor", "Profesionální řidič", "Cesty po celé Evropě"],
        routes: [
          { route: "Praha — Vídeň", price: "od 280 €" },
          { route: "Praha — Mnichov", price: "od 420 €" },
          { route: "Praha — Baden-Baden", price: "od 580 €" },
          { route: "Praha — Paříž", price: "od 1 100 €" },
          { route: "Praha — Řím", price: "od 1 300 €" },
          { route: "Praha — Barcelona", price: "od 1 500 €" },
        ],
        cta: "Objednat přes WhatsApp",
      },
      cargo: {
        title: "Sprinter celokovový do 3,5 t",
        heroDesc: "Stěhování, nábytek, obchodní zásilky. Celokovový Sprinter s objemem až 14 m³.",
        specs: ["Nosnost do 3,5 t", "Objem až 14 m³", "Celokovová karoserie", "Přeprava nábytku a stěhování", "Tarif 1,2 €/km"],
        routes: [
          { route: "Praha — Vídeň", price: "od 280 €" },
          { route: "Praha — Berlín", price: "od 520 €" },
          { route: "Praha — Amsterdam", price: "od 980 €" },
          { route: "Praha — Paříž", price: "od 1 200 €" },
        ],
        cta: "Objednat přes WhatsApp",
      },
      pallet: {
        title: "Furgon do 3,5 t pod 12 europalet",
        heroDesc: "Paletové a sběrné zásilky pro firmy. Furgon s kapacitou až 12 europalet.",
        specs: ["Nosnost do 3,5 t", "Kapacita 12 europalet", "Paletové zásilky", "Sběrné zásilky pro firmy", "Tarif 1,4 €/km", "Paletové místo od 85 €"],
        routes: [
          { route: "Praha — Berlín", price: "od 580 €" },
          { route: "Praha — Amsterdam", price: "od 1 100 €" },
          { route: "Praha — Paříž", price: "od 1 350 €" },
          { route: "Praha — Madrid", price: "od 1 800 €" },
        ],
        cta: "Objednat přes WhatsApp",
      },
    },
    en: {
      "business-car": {
        title: "Business transfer",
        heroDesc: "Airport meet & greet, business trips across Europe. Comfortable business-class car with a professional driver.",
        specs: ["Luxury business-class sedan", "Professional driver", "On-board Wi-Fi", "Child seat on request", "Transport across Europe"],
        routes: [
          { route: "Prague — city center", price: "from 35 €" },
          { route: "Prague — Vienna", price: "from 180 €" },
          { route: "Prague — Berlin", price: "from 350 €" },
          { route: "Prague — Munich", price: "from 280 €" },
        ],
        cta: "Book via WhatsApp",
      },
      minibus: {
        title: "Minibus 9 seats",
        heroDesc: "Group transfers, tourist and corporate trips across Europe. Comfortable minibus for up to 9 passengers.",
        specs: ["9 comfortable seats", "Air conditioning", "Large luggage space", "Professional driver", "Trips across Europe"],
        routes: [
          { route: "Prague — Vienna", price: "from 280 €" },
          { route: "Prague — Munich", price: "from 420 €" },
          { route: "Prague — Baden-Baden", price: "from 580 €" },
          { route: "Prague — Paris", price: "from 1,100 €" },
          { route: "Prague — Rome", price: "from 1,300 €" },
          { route: "Prague — Barcelona", price: "from 1,500 €" },
        ],
        cta: "Book via WhatsApp",
      },
      cargo: {
        title: "Sprinter full-metal up to 3.5 t",
        heroDesc: "Moves, furniture, business cargo. Full-metal Sprinter with volume up to 14 m³.",
        specs: ["Payload up to 3.5 t", "Volume up to 14 m³", "Full-metal body", "Furniture & moving transport", "Rate 1.2 €/km"],
        routes: [
          { route: "Prague — Vienna", price: "from 280 €" },
          { route: "Prague — Berlin", price: "from 520 €" },
          { route: "Prague — Amsterdam", price: "from 980 €" },
          { route: "Prague — Paris", price: "from 1,200 €" },
        ],
        cta: "Book via WhatsApp",
      },
      pallet: {
        title: "Van up to 3.5 t for 12 europallets",
        heroDesc: "Pallet and groupage cargo for businesses. Van with capacity up to 12 europallets.",
        specs: ["Payload up to 3.5 t", "Capacity 12 europallets", "Pallet shipments", "Groupage cargo for businesses", "Rate 1.4 €/km", "Pallet place from 85 €"],
        routes: [
          { route: "Prague — Berlin", price: "from 580 €" },
          { route: "Prague — Amsterdam", price: "from 1,100 €" },
          { route: "Prague — Paris", price: "from 1,350 €" },
          { route: "Prague — Madrid", price: "from 1,800 €" },
        ],
        cta: "Book via WhatsApp",
      },
    },
  },
  routesPage: {
    cs: {
      title: "Trasy a ceny",
      subtitle: "Přehled tras a orientačních cen pro naše služby. Konečná cena závisí na konkrétních podmínkách přepravy.",
      tabPassenger: "Osobní přeprava",
      tabCargo: "Nákladní přeprava",
      businessCarTitle: "Business transfer",
      minibusTitle: "Mikrobus 9 míst",
      cargoTitle: "Sprinter celokovový",
      palletTitle: "Furgon 12 europalet",
      colRoute: "Trasa",
      colPrice: "Cena",
      cargoNote: "Tarif: 1,2 €/km",
      palletNote: "Tarif: 1,4 €/km · Paletové místo od 85 €",
    },
    en: {
      title: "Routes & Prices",
      subtitle: "Overview of routes and indicative prices for our services. The final price depends on specific transport conditions.",
      tabPassenger: "Passenger transport",
      tabCargo: "Cargo transport",
      businessCarTitle: "Business transfer",
      minibusTitle: "Minibus 9 seats",
      cargoTitle: "Sprinter full-metal",
      palletTitle: "Van 12 europallets",
      colRoute: "Route",
      colPrice: "Price",
      cargoNote: "Rate: 1.2 €/km",
      palletNote: "Rate: 1.4 €/km · Pallet place from 85 €",
    },
  },
  about: {
    cs: {
      title: "O nás",
      story: "Jsme malá rodinná přepravní společnost z České republiky. Náš tým čtyř profesionálních řidičů zajišťuje spolehlivou osobní i nákladní přepravu po celé Evropě. Každou cestu bereme osobně — od prvního kontaktu až po doručení na místo.",
      storyP2: "Specializujeme se na VIP transfery, skupinové přepravy a logistická řešení pro firmy. Díky flexibilitě malé firmy dokážeme nabídnout individuální přístup a konkurenceschopné ceny.",
      fleetTitle: "Náš vozový park",
      fleet: [
        { name: "Osobní vůz business třídy", desc: "Luxusní sedan pro VIP transfery a obchodní cesty" },
        { name: "Mikrobus 9 míst", desc: "Skupinové transfery, turistické a firemní přepravy" },
        { name: "Sprinter celokovový do 3,5 t", desc: "Stěhování, nábytek, obchodní zásilky — objem až 14 m³" },
        { name: "Furgon do 3,5 t pod 12 europalet", desc: "Paletové a sběrné zásilky pro firmy" },
      ],
      teamTitle: "Náš tým",
      teamDesc: "4 profesionální řidiči s mnohaletými zkušenostmi v mezinárodní přepravě.",
    },
    en: {
      title: "About us",
      story: "We are a small family transport company from the Czech Republic. Our team of four professional drivers provides reliable passenger and cargo transport across Europe. We take every trip personally — from first contact to delivery.",
      storyP2: "We specialize in VIP transfers, group transport, and logistics solutions for businesses. Thanks to the flexibility of a small company, we can offer a personalized approach and competitive prices.",
      fleetTitle: "Our fleet",
      fleet: [
        { name: "Business-class car", desc: "Luxury sedan for VIP transfers and business trips" },
        { name: "Minibus 9 seats", desc: "Group transfers, tourist and corporate transport" },
        { name: "Sprinter full-metal up to 3.5 t", desc: "Moves, furniture, business cargo — volume up to 14 m³" },
        { name: "Van up to 3.5 t for 12 europallets", desc: "Pallet and groupage cargo for businesses" },
      ],
      teamTitle: "Our team",
      teamDesc: "4 professional drivers with years of experience in international transport.",
    },
  },
  contacts: {
    cs: {
      title: "Kontakty",
      subtitle: "Zavolejte nám nebo napište přes WhatsApp či Telegram. Jsme tu pro vás.",
      phone: "Telefon",
      whatsapp: "WhatsApp",
      telegram: "Telegram",
    },
    en: {
      title: "Contacts",
      subtitle: "Call us or write via WhatsApp or Telegram. We are here for you.",
      phone: "Phone",
      whatsapp: "WhatsApp",
      telegram: "Telegram",
    },
  },
  faq: {
    cs: {
      title: "Časté dotazy",
      items: [
        { q: "Jak si mohu objednat přepravu?", a: "Kontaktujte nás telefonicky, přes WhatsApp nebo Telegram na čísle +420 607 179 165. Domluvíme se na všech detailech vaší cesty." },
        { q: "Jaké platební metody přijímáte?", a: "Přijímáme hotovost i bezhotovostní platbu bankovním převodem. Platba probíhá po dokončení přepravy nebo předem dle dohody." },
        { q: "Jak daleko předem je třeba objednat?", a: "Doporučujeme objednat alespoň 24 hodin předem. U větších zakázek nebo mezinárodních tras doporučujeme 2-3 dny předem." },
        { q: "Jsou ceny konečné?", a: "Uvedené ceny jsou orientační a závisí na konkrétních podmínkách přepravy (datum, čas, počet zastávek). Konečnou cenu vám sdělíme po konzultaci." },
        { q: "Nabízíte přepravu zvířat?", a: "Ano, po předchozí domluvě je možné přepravit domácí zvířata v osobním voze nebo mikrobusu." },
        { q: "Máte pojištění přepravovaného zboží?", a: "Ano, všechna vozidla jsou plně pojištěna a nákladní přeprava je kryta pojištěním odpovědnosti dopravce." },
        { q: "Je možné objednat zpáteční cestu?", a: "Ano, nabízíme zpáteční cesty se slevou. Kontaktujte nás pro individuální nabídku." },
      ],
    },
    en: {
      title: "FAQ",
      items: [
        { q: "How can I order a transport?", a: "Contact us by phone, WhatsApp or Telegram at +420 607 179 165. We will arrange all the details of your trip." },
        { q: "What payment methods do you accept?", a: "We accept cash and bank transfer. Payment is made after transport completion or in advance by agreement." },
        { q: "How far in advance should I book?", a: "We recommend booking at least 24 hours in advance. For larger orders or international routes, 2-3 days in advance is recommended." },
        { q: "Are the prices final?", a: "The listed prices are indicative and depend on specific transport conditions (date, time, number of stops). We will tell you the final price after consultation." },
        { q: "Do you offer pet transport?", a: "Yes, by prior arrangement it is possible to transport pets in a car or minibus." },
        { q: "Do you have cargo insurance?", a: "Yes, all vehicles are fully insured and cargo transport is covered by carrier liability insurance." },
        { q: "Is it possible to book a return trip?", a: "Yes, we offer return trips at a discount. Contact us for an individual offer." },
      ],
    },
  },
  footer: {
    cs: { rights: "Všechna práva vyhrazena.", company: "Transloggroup s.r.o." },
    en: { rights: "All rights reserved.", company: "Transloggroup s.r.o." },
  },
};
